exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-h2 {\r\n  margin: 10px;\r\n}\r\n\r\n.example-section {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  height: 60px;\r\n}\r\n\r\n.example-margin {\r\n  margin: 0 10px;\r\n}\r\n\r\n.connected {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n}\r\n\r\n.connected:after {\r\n  content: '';\r\n  background-color: green;\r\n  border-color: white;\r\n  border-radius: 50%;\r\n  border-width: 5px;\r\n  height: 25px;\r\n  width: 25px;\r\n  margin-bottom: 5px;\r\n  margin-left: 5px;\r\n}\r\n\r\n.disconnected {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n}\r\n\r\n.disconnected:after {\r\n  content: '';\r\n  background-color: red;\r\n  border-color: white;\r\n  border-radius: 50%;\r\n  border-width: 5px;\r\n  height: 25px;\r\n  width: 25px;\r\n  margin-bottom: 5px;\r\n  margin-left: 5px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/StatisticsCanteen/statisticsCanteen.component.css
// module id = ./src/app/StatisticsCanteen/statisticsCanteen.component.css
// module chunks = 1